module.exports = new __parcel__URL__("mining_cancel_mission_button.c5b92c02.png").toString();